import React from 'react';
import './CurvedCutoutMedia.css';
import OptimizedImage from './OptimizedImage';

const CurvedCutoutMedia = ({
  imageSrc,
  imageAvif,
  imageWebp,
  imageMobileAvif,
  imageMobileWebp,
  imageMobileSrc,
  mobileMedia,
  imageAlt,
  className = '',
}) => {
  return (
    <div className={`curved-cutout-media ${className}`.trim()}>
      {(imageAvif || imageWebp) ? (
        <OptimizedImage
          className='curved-cutout-media__image'
          avif={imageAvif}
          webp={imageWebp}
          fallback={imageSrc}
          mobileAvif={imageMobileAvif}
          mobileWebp={imageMobileWebp}
          mobileFallback={imageMobileSrc}
          {...(mobileMedia ? { mobileMedia } : {})}
          alt={imageAlt}
        />
      ) : (
        <img className='curved-cutout-media__image' src={imageSrc} alt={imageAlt} />
      )}
      <div className='curved-cutout-media__mask'>
        <div className='curved-cutout-media__mask-top'></div>
        <svg
          className='curved-cutout-media__mask-svg'
          viewBox='0 0 1440 68'
          preserveAspectRatio='xMidYMin slice'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0 0H630.4C647.8 0 664.2 9.8 675.2 26.5L676.8 28.2C699.6 63.2 743.4 62.7 765.7 27.1C776.4 10 792.9 0 810.5 0H1440V68H0V0Z' />
        </svg>
      </div>
    </div>
  );
};

export default CurvedCutoutMedia;
